import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CHECKOUT_FEATURE, CheckoutRootModule } from '@spartacus/checkout/base/root';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CheckoutBillingAddressModule } from './checkout-billing-address/checkout-billing-address.module';
import { CheckoutDeliveryModeModule } from './checkout-delivery-mode/checkout-delivery-mode.module';
import { CheckoutOrderReviewModule } from './checkout-order-review/checkout-order-review.module';
import { CheckoutOrderTypeModule } from './checkout-order-type/checkout-order-type.module';
import { CheckoutPaymentDetailsModule } from './checkout-payment-details/checkout-payment-details.module';
import { CheckoutPaymentModeSelectorModule } from './checkout-payment-mode-selector/checkout-payment-mode-selector.module';
import { CheckoutPlaceOrderModule } from './checkout-place-order/checkout-place-order.module';
import { CheckoutShippingAddressModule } from './checkout-shipping-address/checkout-shipping-address.module';
import { SnappayPlaceOrderModule } from './snappay-place-order/snappay-place-order.module';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CheckoutRootModule,
    CheckoutOrderTypeModule,
    CheckoutDeliveryModeModule,
    CheckoutShippingAddressModule,
    CheckoutBillingAddressModule,
    CheckoutOrderReviewModule,
    CheckoutPaymentDetailsModule,
    CheckoutPlaceOrderModule,
    CheckoutPaymentModeSelectorModule,
    SnappayPlaceOrderModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('@spartacus/checkout/base').then((m) => m.CheckoutModule),
        },
      },
    }),
  ],
})
export class ShimanoCheckoutModule {}
